import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpService} from "./http.service";
import {Observable} from "rxjs/Observable";
import {Response} from "@angular/http";

@Injectable()
export class BackendService {

    private backendUrl: string;

    constructor(private http: HttpService) {
        this.backendUrl = environment.backendUrl;
    }

    /**
     * Update user.status
     * @param {string} status
     * @returns {Observable<Response>}
     */
    postProfileStatus(status: string): Observable<Response> {
        return this.http.post(
            this.backendUrl + 'api/profile/status',
            JSON.stringify({status: status})
        );
    }
}


// WEBPACK FOOTER //
// /code/frontend/src/app/core/services/backend.service.ts